(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTplDeleteController',PatientOrderTplDeleteController);

    PatientOrderTplDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientOrderTpl'];

    function PatientOrderTplDeleteController($uibModalInstance, entity, PatientOrderTpl) {
        var vm = this;

        vm.tpl = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientOrderTpl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
